











































































































































import { mapGetters } from 'vuex';
import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { SearchPayload } from '@/Stores/AppealStore';
import { SearchParams } from './Citation/SearchParams';
import { formatDate, formatTime } from '@/Shared/Filters';

export default mixins(LocationBasedMixin).extend({
    data() {
        return {
            i18nPrefix: 'appeals.previousAppeals'
        };
    },
    computed: {
        ...mapGetters('appealModule', [
            'searchError',
            'searchInProgress',
            'getSearchResults',
            'getPreviousList',
            'previousListLoaded'
        ]),
        previousAppealList() {
            let list: any[] = [];
            if (this.getPreviousList.length) {
                list = this.getPreviousList;
                list = list.filter(s => {
                    if (s.dateAppealed != null && s.dateAppealed !== undefined) {
                        return s;
                    }
                });
            }
            return list;
        }
    },
    mounted() {
        if (!this.getSearchResults.citationNumber) {
            return;
        }

        const searchParams = new SearchParams();
        searchParams.citationNumber = this.getSearchResults.citationNumber;
        searchParams.vehicleLicense = this.getSearchResults.vehicleLicense;
        searchParams.vehicleState = this.getSearchResults.vehicleState;

        if (this.previousListLoaded) {
            return;
        }

        const payload: SearchPayload = {
            parameters: searchParams,
            location: this.$typedStore.state.currentLocation
        };

        this.$typedStore.modules.appealModule.actions.loadPreviousList(payload);
    },
    methods: {
        formatDateTime(date: Date): string {
            return formatDate(date) + ' ' + formatTime(date);
        },
    }
});
